<template>
  <div class="mobile-contenttop-box">
    <div class="mobile-top">
      <div class="mobile-left">
        <div class="mobile-en-title">{{ cate.en }}</div>
        <div class="mobile-cn-title">{{ cate.title }}</div>
      </div>
      <div class="mobile-center" @click="$emit('toInfo', list[0].id)">
        <div
          style="
            width: 18.75rem;
            height: 13.875rem;
            overflow: hidden;
            margin: 0 auto;
          "
        >
          <img
            :src="getImgUrl(list[0].thumb)"
            alt=""
            class="mobile-icon hvr-grow"
          />
        </div>
        <div class="mobile-title">{{ list[0].title }}</div>
        <div class="mobile-text">{{ list[0].describe || "" }}</div>
      </div>
    </div>
    <div
      class="mobile-right"
      v-for="(item, index) in list.slice(1)"
      :key="index"
      @click="$emit('toInfo', item.id)"
    >
      <div>
        <img :src="getImgUrl(item.thumb)" alt="" class="mobile-icon hvr-grow" />
      </div>
      <div class="mobile-title">{{ item.title }}</div>
      <div class="mobile-text">{{ item.describe || "" }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    cate: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      infoData: {
        enTitle: "BRAND",
        cnTitle: "品牌设计",
        centerImg: "",
        centerTitle: "",
        centerText: "",
        rightImg: "",
        rightTitle: "",
        rightText: "",
      },
    };
  },
  mounted() {
    console.log("list,cate", this.list, this.cate);

    // switch (this.indexNum) {
    //   case 1:
    //     this.infoData = {
    //       enTitle: "BRAND",
    //       cnTitle: "品牌设计",
    //       centerImg: require("@/assets/case/img (1).png"),
    //       centerTitle: "帛萦芝造品牌设计",
    //       centerText: "品牌设计",
    //       rightImg: require("@/assets/case/img (13).png"),
    //       rightTitle: "喜誉居品牌设计",
    //       rightText: "品牌设计",
    //     };
    //     break;
    //   case 2:
    //     this.infoData = {
    //       enTitle: "SYSTEM",
    //       cnTitle: "系统开发",
    //       centerImg: require("@/assets/case/img (9).png"),
    //       centerTitle: "局气-会员",
    //       centerText: "系统开发",
    //       rightImg: require("@/assets/case/img (6).png"),
    //       rightTitle: "电力督办管理系统",
    //       rightText: "系统开发",
    //     };
    //     break;
    //   case 3:
    //     this.infoData = {
    //       enTitle: "WEBSITE",
    //       cnTitle: "高端网站",
    //       centerImg: require("@/assets/case/img (12).png"),
    //       centerTitle: "首都机场航空服务产教融合信息平台",
    //       centerText: "网站开发",
    //       rightImg: require("@/assets/case/img (10).png"),
    //       rightTitle: "德武龙传承教育",
    //       rightText: "网站开发",
    //     };
    //     break;
    // }
  },
};
</script>
<style scoped>
.mobile-contenttop-box {
  width: 46.875rem;
  background: #0d0d0d;
}

.mobile-contenttop-box .mobile-top {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  justify-content: space-between;
}

.mobile-contenttop-box .mobile-top .mobile-left {
  margin-left: 3.8125rem;
}

.mobile-contenttop-box .mobile-top .mobile-left .mobile-en-title {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 1.25rem;
  color: #e3b281;
}

.mobile-contenttop-box .mobile-top .mobile-left .mobile-cn-title {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 2rem;
  color: #e3b281;
  margin-top: 1rem;
}

.mobile-contenttop-box .mobile-top .mobile-center {
  margin-right: 3.8125rem;
}

.mobile-contenttop-box .mobile-top .mobile-center .mobile-icon {
  width: 18.75rem;
  height: 13.875rem;
  border-radius: 0.3125rem;
}

.mobile-contenttop-box .mobile-top .mobile-center .mobile-title {
  font-weight: 400;
  font-size: 1.75rem;
  color: #ffffff;
  margin: 1.875rem 0 1.25rem 0;
}

.mobile-contenttop-box .mobile-right {
  padding: 0 2.5rem;
}

.mobile-contenttop-box .mobile-right .mobile-icon {
  width: 41.875rem !important;
  height: 29.91rem !important;
  border-radius: 0.3125rem;
}

.mobile-contenttop-box .mobile-right .mobile-title {
  font-weight: 400;
  font-size: 1.75rem;
  color: #ffffff;
  margin: 1.5rem 0 2.5rem 0;
}

.mobile-contenttop-box .mobile-right .mobile-text {
  font-weight: 400;
  font-size: 1.25rem;
  color: #ffffff;
  opacity: 0.3;
}
</style>
